import check_checkbox from './contact-form-gdpr.js';
import wp_sliders from './wp_sliders.js';
import {
  max_height_double_image_block,
  image_text_fill_height,
  animate_achievement,
  animate_number_when_scrolling,
  imagebank_block_functionality,
  embed_video,
  scale_hero_text,
  block_column_images,
  block_column_fullwidth,
  feature_block,
  faq_block
 } from './wp_block_scripts.js';

import mobile_menu from './mobile-menu.js';
import header from './header.js';

export default function kyrktak_wp() {
  scale_hero_text();
  init();
  check_checkbox();
  max_height_double_image_block();
  image_text_fill_height();
  imagebank_block_functionality();
  embed_video();
  //block_column_fullwidth();
  //block_column_images();
  feature_block();
  wp_sliders();
  header();
  faq_block();
  animate_number_when_scrolling();

  function init() {
    $(window).scroll(animate_number_when_scrolling);
  }

  $(window).load(()=> {
      block_column_images();
      block_column_fullwidth();
    })

  if($('body').attr('class').includes('woocommerce')) {
    const wc_functions = require('./woocommerce/wc-kyrktak.js');
    wc_functions.default();
  }
}
